const locale: Locale = {
  ko: {
    findPassword: '비밀번호 찾기',
    useGistEmail: '지스트 이메일을 사용해주세요.',
    codeSent: '으로 인증코드가 전송되었습니다.',
    notUser: '존재하지 않는 회원입니다.',
    notCode: '존재하지 않는 인증 코드 입니다.',
    expiredCode: '만료된 인증 코드 입니다.',
    newPwd: '새로운 비밀번호를 입력하세요',
    confirmPwd: '새로운 비밀번호를 재입력하세요',

    diffPwd: '비밀번호가 일치하지 않습니다.',
    formatPwd: '영문과 숫자를 포함한 8자리 이상의 비밀번호를 설정해주세요',

    codeBtn: '인증코드 전송',
    reCodeBtn: '인증코드 재전송',
    verifyBtn: '인증',
    reVerifyBtn: '재인증',
    changePwdBtn: '비밀번호 재설정',

    success: '성공!',
    pwdChanged: '비밀번호가 재설정되었습니다.',
  },
  en: {
    findPassword: 'Find Password',
    useGistEmail: "Enter your 'GIST' email.",
    codeSent: ' - Verification code has been sent.',
    notUser: 'No accounts were found for this email',
    notCode: 'The verification code is not correct. Try again.',
    expiredCode: 'Verification code was expired',
    newPwd: 'new password',
    confirmPwd: 'confirm new password',

    diffPwd: 'Passwords do not match.',
    formatPwd:
      'Password must be at least 8 characters and contain both numbers and letters.',

    codeBtn: 'Send Verification Code',
    reCodeBtn: 'Resend Verification Code',
    verifyBtn: 'Verify',
    reVerifyBtn: 'Re-verify',

    changePwdBtn: 'Change Password',

    success: 'Success!',
    pwdChanged: 'Password was changed.',
  },
}

export default locale
